import { TabPanel, TabView } from "primereact/tabview"
export type MenuItem = {
    icon: JSX.Element
    label: string,
}
type Props = {
    index: number,
    setIndex: Function,
    menuItems: MenuItem[]
}
function Menu(props: Props) {
    return (
        <>
            <div style={{ width: '100%', borderColor: '#ddd', border: 1, borderStyle: 'solid' }} />
            <TabView style={{ backgroundColor: 'lightgray' }} activeIndex={props.index} onTabChange={(e) => props.setIndex(e.index)} scrollable>
                {props.menuItems.map((tab: MenuItem) => {
                    return (<TabPanel header={
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            {tab.icon}
                            <div style={{ fontSize: 10, marginTop: 5 }}>
                                {tab.label}
                            </div>
                        </div>
                    } />)
                })}
            </TabView>
        </>
    )
}

export default Menu